import { VacancyItem } from './VacancyItem';
import { Vacancy } from '../../../../network/ats';

export const VacanciesList = ({ vacancies }: { vacancies: Vacancy[] }) => (
  <div className="flex w-full flex-col gap-3 p-4 sm:p-6">
    {vacancies.map((vacancy) => (
      <VacancyItem key={vacancy.id} vacancy={vacancy} />
    ))}
  </div>
);
